import { type InfiniteData } from '@tanstack/react-query';

import { type Accounts, type Query } from '@pkg/graphql/codegen/graphql';

import { type GraphQLResult } from '@app/client';

export function parseData(response: InfiniteData<GraphQLResult<Query>, string>) {
    const pages = (response.pages
        ?.flatMap(({ data }) => {
            if (data?.accounts) {
                return data.accounts;
            }
        })
        .filter(Boolean) || []) as Accounts[];
    const pagesData = pages.flatMap(({ value }) => value).filter(Boolean);
    return {
        ...response,
        pages,
        pagesData,
    };
}
